// Shared contracts for the maintenance schemas and their runtime validation.
// Editors offer 1–10 plus Unlimited, but preserve larger saved limits. All
// scenario models store a nullable signed 32-bit integer; do not truncate input
// with parseInt or impose the dropdown's suggested values on existing records.
export const maxTurnsSchema = {
  type: ["integer", "null"],
  minimum: 1,
  maximum: 2147483647,
  description: "Maximum conversation turns (positive whole number). Pass null for Unlimited; omit to keep the current limit. Question mode requires Unlimited.",
};

// The scenario enums, as the Prisma schema spells them. The generated client
// does not publish them in a form a browser bundle may import, so this is
// their one JavaScript home: the maintenance schemas, the API routes and the
// create tools all read from here rather than restating the values.
export const playChannelSchema = {
  type: "string",
  enum: ["INBOUND", "OUTBOUND"],
  description: "Play channel: INBOUND or OUTBOUND. Omit to keep the current channel.",
};

export const customerStatusSchema = {
  type: "string",
  enum: ["NEW_CUSTOMER", "EXISTING_CUSTOMER"],
  description: "Whether the buyer is a new or an existing customer. Omit to keep the current value.",
};

export const contactTypeSchema = {
  type: "string",
  enum: ["FIRST_CONTACT", "FOLLOW_UP_CONTACT"],
  description: "Whether this is a first contact or a follow-up. Omit to keep the current value.",
};

export function normalizeMaxTurns(value) {
  if (value === null) return null;
  if (!Number.isInteger(value) || value < maxTurnsSchema.minimum || value > maxTurnsSchema.maximum) {
    throw new TypeError("maxTurns must be a positive whole number up to 2147483647, or null for Unlimited.");
  }
  return value;
}

function enumNormalizer(field, schema) {
  return (value) => {
    if (!schema.enum.includes(value)) {
      throw new TypeError(`${field} must be ${schema.enum.join(" or ")}.`);
    }
    return value;
  };
}

export const normalizePlayChannel = enumNormalizer("channel", playChannelSchema);
export const normalizeCustomerStatus = enumNormalizer("customerStatus", customerStatusSchema);
export const normalizeContactType = enumNormalizer("contactType", contactTypeSchema);

/**
 * What a generated candidate's loose spelling ("inbound", "", undefined)
 * stores: the enum value it names, else the schema's own default. Used where
 * a draft is being saved rather than validated, so a model's guess never
 * fails the save.
 */
function enumCoercer(schema, fallback) {
  return (value) => {
    const key = String(value || "").trim().toUpperCase();
    return schema.enum.includes(key) ? key : fallback;
  };
}

export const coercePlayChannel = enumCoercer(playChannelSchema, "OUTBOUND");
export const coerceCustomerStatus = enumCoercer(customerStatusSchema, "NEW_CUSTOMER");
export const coerceContactType = enumCoercer(contactTypeSchema, "FIRST_CONTACT");

export function describeScenarioSettings(record) {
  return {
    ...(record.channel === "INBOUND" || record.channel === "OUTBOUND"
      ? { channel: record.channel === "INBOUND" ? "Inbound" : "Outbound" } : {}),
    maxTurns: record.maxTurns == null ? "Unlimited" : `${record.maxTurns} ${record.maxTurns === 1 ? "turn" : "turns"}`,
  };
}
